import React, { useRef, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { widgetHeight, widgetWidth } from '..';
import { Dropdown, Popup, Message as SemanticMessage } from 'semantic-ui-react';
import { BottomButtonRow, Message, CardBodyWrapper } from '../Styles';
import { ButtonWithConfirmation } from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { engineToolType } from '../../../../stores/reducers/engineTools';

const getStreamerOptions = (data) =>
  data?.map(({ streamerID, streamer }) => ({
    key: streamerID,
    text: streamer,
    value: streamerID,
  })) ?? [];

export const StreamerRebootWidget = observer(() => {
  const {
    EngineToolStore: {
      data,
      engineFetch: fetch,
      enginePost: post,
      widgetReloading,
    },
  } = useStores();
  const [streamerValue, setStreamerValue] = useState();
  const [streamers, setStreamers] = useState(data);
  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);
  const key = 'reboot-streamer';

  const statusMessageHandler = ({ success, message }) => {
    setMessage(success ? 'Success' : message);
    setSuccess(success);
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    if (streamerValue) {
      post(engineToolType.rebootStreamer, {
        streamerID: streamerValue,
      }).then(statusMessageHandler);
      return;
    }
  };

  useEffect(() => {
    fetch(engineToolType.getStreamers);
  }, [streamers]);

  const isLoading =
    widgetReloading[engineToolType.getStreamers] ||
    widgetReloading[engineToolType.rebootStreamer];

  return (
    <WidgetCard
      heading="Reboot Streamer"
      description={null}
      width="450px"
      height="300px"
    >
      <CardBodyWrapper>
        <SemanticMessage
          warning
          header="Think TWICE before doing this!"
          content="This action will Reboot the Host Server, drop ALL connections, clear ALL Media Tokens, and force everyone in auction to re-connect.  This will cause a 15 minute delay to the Auction."
        />
        <Dropdown
          placeholder="Select Streamer"
          clearable
          fluid
          selection
          options={getStreamerOptions(data)}
          onChange={(e, data) => {
            setStreamerValue(data.value);
            if (!data?.value)
              statusMessageHandler({ success: null, message: null });
          }}
          value={streamerValue}
        />
      </CardBodyWrapper>
      <BottomButtonRow buttonWidth="190px">
        {message ? (
          <Popup
            data-testid={`${key}-popup`}
            key={key}
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? '😃 Streamer has been rebooted. Will take a moment to restart!'
                  : '🤔 Oops, an error occurred while trying to reboot the streamer.'}
              </Message>
            }
          />
        ) : (
          <Message />
        )}

        <ButtonWithConfirmation
          buttonText="Reboot"
          buttonIcon="shutdown"
          onConfirmation={handleConfirmation}
          disabled={!streamerValue}
          loading={isLoading}
        />
      </BottomButtonRow>
    </WidgetCard>
  );
});

export default StreamerRebootWidget;
